export const isFeatureEnabled = (features, flagName) => {
  if (!features || !flagName) {
    return false;
  }

  return features[flagName] === true;
};

export const areAllFeaturesEnabled = (features, flagNames = []) => {
  if (!Array.isArray(flagNames) || flagNames.length === 0) {
    return true;
  }

  return flagNames.every((flagName) => isFeatureEnabled(features, flagName));
};

export const canAccessWithFeature = (permissionAllowed, features, flagName) => (
  Boolean(permissionAllowed) && isFeatureEnabled(features, flagName)
);

export const canAccessWithFeatures = (permissionAllowed, features, flagNames = []) => (
  Boolean(permissionAllowed) && areAllFeaturesEnabled(features, flagNames)
);
